module.exports = __webpack_public_path__ + "static/media/pk4media-logo.e375c6fa.svg";